export const authHeaders = (token) => {
  const authToken = !token ? localStorage.getItem('token') : token;
  return {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
};
